import React from "react";
import "./Intro.css";
import CTASecondary from "../CTASecondary";

function Intro() {
  return (
    <div className="Intro">
      <h1>Introducing the exclusive life in costa blanca</h1>

      <div className="Intro__paragraph">
        <div className="Intro__paragraph__size">
          <p>
            Welcome to an exquisite world where luxury meets tranquility - the
            stunning Costa Blanca in Spain. Here, amidst the azure Mediterranean
            waters and picturesque landscapes, lies an unparalleled opportunity
            for investment and leisure.
          </p>
          <p>
            Our curated collection of exclusive properties showcases the epitome
            of elegance and sophistication. Each residence is a masterpiece,
            meticulously crafted to embody the essence of luxury living. From
            contemporary villas boasting panoramic sea views to opulent estates
            nestled in idyllic coastal settings, our portfolio caters to the
            most discerning tastes.
          </p>
          <p>
            With its vibrant real estate market and favorable economic climate,
            Costa Blanca presents a promising prospect for investors seeking
            high returns. Whether you're looking for a lucrative rental income
            or a vacation home with a long-term asset appreciation, our
            properties offer a solid foundation for your investment portfolio.
          </p>
        </div>
      </div>

      <div className="Intro__alignbutton">
        <a href="/properties">
          <CTASecondary label="View properties" />
        </a>
      </div>
    </div>
  );
}

export default Intro;
